import { memo, useCallback, useMemo } from 'react';

import { useParams } from 'react-router-dom';

import { FilterPopover } from 'components/FilterComponents/FilterPopover/FilterPopover';
import {
  FilterOption,
  FilterType
} from 'components/FilterComponents/FilterPopover/types';
import { OfferDesignTypes } from 'views/OffersUI/OffersUIForm/types';

import { useOfferDesignOptions } from '../../hooks/useOfferDesignOptions';

interface IOfferDesignFilterProps {
  offerDesignType: OfferDesignTypes;
  selected: string[];
  onToggle: (id: string) => void;
}

export const OfferDesignFilter = memo(
  ({ offerDesignType, selected, onToggle }: IOfferDesignFilterProps) => {
    const { publisherId } = useParams();

    const { offerDesignOptions } = useOfferDesignOptions({
      publisherId: publisherId ?? '',
      offerDesignType
    });

    const options: FilterOption[] = useMemo(
      () =>
        offerDesignOptions.map(
          (o: { value: string; label: string }): FilterOption => ({
            label: o.label,
            value: o.value
          })
        ),
      [offerDesignOptions]
    );

    const handleChange = useCallback(
      (id: string): void => {
        onToggle(id);
      },
      [onToggle]
    );

    return (
      <FilterPopover
        label="Offer Design"
        filterType={FilterType.AUTOCOMPLETE_CHECKLIST}
        options={options}
        selectedItems={selected}
        onChange={handleChange}
        placeholder="Search offer design"
        dataTestId="offers-offer-design-filter"
      />
    );
  }
);

OfferDesignFilter.displayName = 'OfferDesignFilter';
